import { DEFAULT_WIDTH_SIZES_PX } from 'shared/build/constants';
import { useLocation } from 'react-router-dom';
import { ShoppingCart } from 'shared/build/types';
import { ShoppingCartUI } from './types';
import { Money } from 'shared/build/Money';

export const convertImageIdToSrcSet = (id: string): string => {
  return DEFAULT_WIDTH_SIZES_PX.map<string>((width) => {
    let url = `/pictures/${getTenantFromUrl()}/${id}-w${width}.png ${width}w`;

    if (process.env.NODE_ENV === 'development') {
      url = process.env.REACT_APP_IMAGE_SERVICE + url;
    }

    return url;
  }).join(', ');
};

export const getTenantFromUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_TENANT || '';
  }

  return window.location.hostname.split('.')[0];
};

export const customFetch = (
  url: string,
  init?: RequestInit
): Promise<Response> => {
  const initForCall: RequestInit = {
    ...{
      headers: {
        'Content-Type': 'application/json',
      },
    },
    ...init,
  };
  return fetch(url, initForCall);
};

export const useQueryString = (): URLSearchParams => {
  return new URLSearchParams(useLocation().search);
};

export const convertShoppingCartToUI = (
  shoppingCartUI: ShoppingCart
): ShoppingCartUI => {
  const items: ShoppingCartUI['items'] = {};
  Object.entries(shoppingCartUI.items).forEach(([key, value]) => {
    items[key] = {
      ...value,
      unitPrice: new Money(value.unitPrice, value.currency),
    };
  });

  return {
    ...shoppingCartUI,
    items,
  };
};
